module.exports = __webpack_public_path__ + "img/02—01—02b—Port Forwarding—Create new port forwarding rule 1.aafa4002.jpg";